export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export type CHANGE_LANGUAGE = typeof CHANGE_LANGUAGE;